import gql from 'graphql-tag';

export const DeleteInlineCommentMutationWithStep = gql`
	mutation DeleteInlineCommentMutationWithStep($input: DeleteInlineCommentInput!) {
		deleteInlineComment(input: $input)
	}
`;
